/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './animation-item.stache';
import DomEventsManager from 'scripts/dom-events-manager';
import can from 'can';
import domUtils from 'scripts/utils/dom';

Component.extend({
    tag: 'animation-item',
    template: template,
    viewModel: {
        define: {
            visible: {
                type: 'boolean',
                value: false
            },
            transition: {
                type: 'boolean',
                value: false
            }
        }
    },
    events: {
        inserted: function () {
            this.deferred = can.Deferred();

            this.deferred.promise()
                .then(() => {
                    this.setElementVisible(true);
                })
                .fail(() => {
                    this.setElementVisible(false);
                });

            DomEventsManager.subscribe(this);
        },

        removed: function () {
            DomEventsManager.unsubscribe(this);
        },

        setElementVisible: function (transition) {
            this.viewModel.attr('transition', transition);
            this.viewModel.attr('visible', true);
        },

        onFirstShow: function () {
            this.isFirstShow = true;
            let queue = this.viewModel.attr('queue');

            if (queue) {
                queue.push(this.deferred);
            } else {
                this.deferred.resolve();
            }
        },
        onWindowScrollNow: function () {
            if (this.isFirstShow && !domUtils.isOnScreen(this.element, true)) {
                DomEventsManager.unsubscribe(this);
                if ((this.deferred.state() === 'pending')) {
                    this.deferred.reject();
                } else if (this.deferred.state() === 'resolved') {
                    this.setElementVisible(false);
                }
            }
        }
    }
});
